"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconDownload = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M5,20.5 L19,20.5 L19,18.5 L5,18.5 M19,9.5 L15,9.5 L15,3.5 L9,3.5 L9,9.5 L5,9.5 L12,16.5 L19,9.5 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconDownload')(IconDownload);